// extracted by mini-css-extract-plugin
export default {"asideHeading":"FeaturedContent-module__asideHeading--DgeGj"};